import React, { useEffect } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import HeaderContainer from './HeaderContainer';
import MobileTabBar from './MobileTabBar';
import GlobalSearchResults from './GlobalSearchResults';
import Home from '../pages/Home';
import Grammar from '../pages/Grammar';
import Vocabulary from '../pages/Vocabulary';
import Reading from '../pages/Reading';
import Writing from '../pages/Writing';
import TaskView from '../pages/TaskView';

const AppShell: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className={`app${isHome ? ' app--home' : ''}`}>
      <HeaderContainer />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/grammar" element={<Grammar />} />
          <Route path="/vocabulary" element={<Vocabulary />} />
          <Route path="/reading" element={<Reading />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/grammar/:taskId" element={<TaskView section="grammar" />} />
          <Route path="/vocabulary/:taskId" element={<TaskView section="vocabulary" />} />
          <Route path="/reading/:taskId" element={<TaskView section="reading" />} />
          <Route path="/writing/:taskId" element={<TaskView section="writing" />} />
        </Routes>
      </main>
      {!isHome && <MobileTabBar />}
      <GlobalSearchResults />
    </div>
  );
};

export default AppShell;
